// src/resizeObserverFix.js

const ResizeObserver = window.ResizeObserver;

window.ResizeObserver = class extends ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};
